import axiosInstance from 'api/axiosInstance';

export interface TimeSummaryEntry {
	ContactId: number;
	Name: string;
	ActivityType: string;
	RegularTime: number;
	OverTime: number;
}

async function getCaseTimeSummary(caseId: number): Promise<TimeSummaryEntry[]> {
	try {
		const { data } = await axiosInstance.get(
			`/Portal/Project/WebService/CANTrack.asmx/GetTimeSummary?caseId=${caseId}`,
		);
		if (!data || !Array.isArray(data)) return [];
		return data.map((entry: any) => ({
			ContactId: entry.ContactId,
			Name: entry.Name || '',
			ActivityType: entry.ActivityType || '',
			RegularTime: parseFloat(entry.RegularTime) || 0,
			OverTime: parseFloat(entry.OverTime) || 0,
		}));
	} catch (error) {
		console.error('[getCaseTimeSummary] Failed for case:', caseId, error);
		throw error;
	}
}

export default getCaseTimeSummary;
